import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

function SafeDrivingMainTripItemLoadingKr() {
  const {t} = useInferableTranslation();

  return (
    <div className="major_driving_item skeleton">
      <strong className="major_driving_rank">
        <span className="rank_text">{t('T20017_$n', {n: 1})}</span>
        <span className="count_text">
          <span className="count_value">22</span>
          <span className="count_unit">{t('T20133')}</span>
        </span>
      </strong>
      <div className="major_driving_info">
        <div className="major_driving_action">
          <span className="driving_action">
            <span className="action_text">{t('T10011')}</span>
            <span className="action_value">5</span>
          </span>
          <span className="divider divider_vertical"></span>
          <span className="driving_action">
            <span className="action_text">{t('T10012')}</span>
            <span className="action_value">6</span>
          </span>
          <span className="divider divider_vertical"></span>
          <span className="driving_action">
            <span className="action_text">{t('T10013')}</span>
            <span className="action_value">7</span>
          </span>
          <span className="ic ic_arrow_forward_12px"></span>
        </div>
        <div className="major_driving_detail">
          <span className="driving_date">2024.6.13</span>
          <span className="divider divider_vertical"></span>
          <span className="driving_place">강릉초당순두부</span>
        </div>
      </div>
    </div>
  );
}

export default SafeDrivingMainTripItemLoadingKr;
